<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/products',
    'fr-CA': '/produits'
  }
})

useHead({
  title: t('navigation.products.metatitle'),
  meta: [{ name: 'description', content: t('navigation.products.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.products.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.products.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuProducts />
        <div class="contenu right">
          <div class=""
               v-if="$i18n.locale == 'en-CA'">
            <p>The tissue industry is comprised of two major markets: the <NuxtLink :to="localePath('products-consumerMarket')">Consumer market</NuxtLink>, which consists of the supply of products such as bathroom tissue, facial tissue, paper towels and napkins to consumers through traditional retail channels such as grocery stores, mass merchandisers, club stores, drug stores, convenience stores and online retailers; and the <NuxtLink :to="localePath('products-awayFromHomeMarket')">Away-From-Home market</NuxtLink>, which consists primarily of the supply of bathroom tissue, facial tissue, paper towels and napkins to commercial users in a variety of industries such as food services, property management, healthcare, manufacturing, education and lodging.</p>
          </div>
          <div class=""
               v-if="$i18n.locale == 'fr-CA'">
            <p>L’industrie du papier se compose de deux principaux marchés : le <NuxtLink :to="localePath('products-consumerMarket')">marché de consommation</NuxtLink>, qui consiste en l’offre de produits comme le papier hygiénique, les papiers-mouchoirs, les essuie-tout et les serviettes de table aux consommateurs par l’intermédiaire des canaux de distribution au détail ordinaires – épiceries, magasins à grande surface, clubs-entrepôts, pharmacies, dépanneurs et détaillants en ligne; et le <NuxtLink :to="localePath('products-awayFromHomeMarket')">marché hors foyer</NuxtLink>, qui consiste essentiellement en l’offre de papier hygiénique, de papiers-mouchoirs, d’essuie-tout et de serviettes de table aux utilisateurs commerciaux de différents secteurs comme les services alimentaires, la gestion immobilière, les soins de santé, la fabrication, l’éducation et l’hébergement.</p>
          </div>
          <div class="block3">
            <div class="produits">
              <NuxtLink :to="localePath('products-consumerMarket')">
                <div class="image">
                  <img src="~/assets/images/consumer-market-2022.jpg"
                       alt="Consumer Market">
                </div>
                <div class="contenuBlock">
                  <div class="titre">
                    {{ t("navigation.consumerMarket.name") }}
                  </div>
                  <div class="viewMore">
                    {{ t("home.viewMore") }}
                  </div>
                </div>
              </NuxtLink>
            </div>
            <div class="produits">
              <NuxtLink :to="localePath('products-awayFromHomeMarket')">
                <div class="image">
                  <img src="~/assets/images/away-from-home-market.jpg"
                       alt="Away-From-Home-Market">
                </div>
                <div class="contenuBlock">
                  <div class="titre">
                    {{ t("navigation.awayFromHomeMarket.name") }}
                  </div>
                  <div class="viewMore">
                    {{ t("home.viewMore") }}
                  </div>
                </div>
              </NuxtLink>
            </div>
            <div class="produits">
              <NuxtLink :to="localePath('products-privateLabelMarket')">
                <div class="image">
                  <img src="~/assets/images/kpt-privatelabels-homepage.jpg"
                       alt="Private_label-Market">
                </div>
                <div class="contenuBlock">
                  <div class="titre">
                    {{ t("navigation.privateLabelMarket.name") }}
                  </div>
                  <div class="viewMore">
                    {{ t("home.viewMore") }}
                  </div>
                </div>
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
